/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { TransitionalClientTeamResource } from './';
import {
    TransitionalClientTeamResourceFromJSON,
    TransitionalClientTeamResourceFromJSONTyped,
    TransitionalClientTeamResourceToJSON,
} from './';

/**
 * 
 * @export
 * @interface OrganizationOptionsResource
 */
export interface OrganizationOptionsResource {
    /**
     * 
     * @type {boolean}
     * @memberof OrganizationOptionsResource
     */
    scimActivated: boolean;
    /**
     * 
     * @type {TransitionalClientTeamResource}
     * @memberof OrganizationOptionsResource
     */
    transitionalClientTeam?: TransitionalClientTeamResource;
}

/**
 * Check if a given object implements the OrganizationOptionsResource interface.
 */
export function instanceOfOrganizationOptionsResource(value: object): value is OrganizationOptionsResource {
    if (!('scimActivated' in value) || value['scimActivated'] === undefined) return false;
    return true;
}

export function OrganizationOptionsResourceFromJSON(json: any): OrganizationOptionsResource {
    return OrganizationOptionsResourceFromJSONTyped(json, false);
}

export function OrganizationOptionsResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): OrganizationOptionsResource {
    if (json == null) {
        return json;
    }
    return {
        
        'scimActivated': json['scimActivated'],
        'transitionalClientTeam': json['transitionalClientTeam'] == null ? undefined : TransitionalClientTeamResourceFromJSON(json['transitionalClientTeam']),
    };
}

export function OrganizationOptionsResourceToJSON(value?: OrganizationOptionsResource | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'scimActivated': value['scimActivated'],
        'transitionalClientTeam': TransitionalClientTeamResourceToJSON(value['transitionalClientTeam']),
    };
}

